import { render } from "./v-btn.vue?vue&type=template&id=d73af2da&scoped=true"
import script from "./v-btn.vue?vue&type=script&lang=js"
export * from "./v-btn.vue?vue&type=script&lang=js"

import "./v-btn.vue?vue&type=style&index=0&id=d73af2da&lang=scss&scoped=scoped"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d73af2da"]])

export default __exports__